module.exports = __webpack_public_path__ + "bf5de6710aa11f0394e5d03b5f0292a6.pdf";